import React, { useState, useEffect } from "react";

import { Row, Spin } from "antd";

import MicroErpFirmReport from "./Micro/ErpFirmReport";
import NetsisErpFirmReport from "./Netsis";
import LogoErpFirmReport from "./Logo/ErpFirmReport";

import RequestHandler from "util/RequestHandler";

const ErpReportPage = (props) => {
  const [tenantErpProgram, setTenantErpProgram] = useState({ data: null, loading: true });

  useEffect(() => {
    RequestHandler.get(`/TenantErpProgram/GetByTenant`).then((response) => {
      setTenantErpProgram({
        data: response,
        loading: false,
      });
    });
  }, [])

  const allowErpProgram = [1,2,3];

  return (
    <>
      {tenantErpProgram.loading && (
        <Row align="middle" justify="center" style={{ height: "100%" }}>
          <Spin spinning={true} />
        </Row>
      )}

      {!tenantErpProgram.loading && tenantErpProgram.data === null && (
        <Row align="middle" justify="center" style={{ height: "100%" }}>
          Firmanızın tanımlı bir erp programı bulunmuyor.
        </Row>)}
      {!allowErpProgram.includes(tenantErpProgram.data?.erpProgramId) && ( <Row align="middle" justify="center" style={{ height: "100%" }}>
          Firmanızda tanımlı erp programının bayi takip listesi bulunmuyor.
        </Row>)}

      {tenantErpProgram.data?.erpProgramId === 1 && (<MicroErpFirmReport />)}
      {tenantErpProgram.data?.erpProgramId === 3 && (<NetsisErpFirmReport />)}
      {tenantErpProgram.data?.erpProgramId === 2 && (<LogoErpFirmReport />)}

      
    </>
  );
};

export default ErpReportPage;
